<template>
    <v-select
        v-model="answers"
        :items="answerItems"
        :multiple="multiSelect"
        item-text="displayName"
        :placeholder="$t('pleaseSelect')"
        solo
        chips
        deletable-chips
        clearable
        @change="onChange"
    >
        <template #selection="{ item }">
            <v-chip color="primary" text-color="fl-primary-text">{{ item.displayName }}</v-chip>
        </template>
    </v-select>
</template>

<script lang="ts">
import { PropType } from 'vue';
import { Vue } from 'vue-property-decorator';
import { ShoppingGuideAnswerItem } from '../definitions';

export default Vue.extend({
    name: 'ShoppingGuideDropdown',
    props: {
        answerItems: {
            type: Array as PropType<ShoppingGuideAnswerItem[]>,
            required: true,
        },
        selectedAnswers: {
            type: Array as PropType<string[]>,
            required: true,
        },
        multiSelect: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            answers: this.multiSelect ? [...this.selectedAnswers] : this.selectedAnswers[0],
        };
    },
    methods: {
        onChange(eventData: string | string[] | null) {
            if (!eventData || !eventData.length) {
                this.$emit('answersRemoved');
            } else {
                this.$emit('answersChanged', Array.isArray(eventData) ? eventData : [eventData]);
            }
        },
    },
});
</script>

<style scoped lang="scss">
.v-select::v-deep {
    input {
        // Resets default styling from Shopware 5
        box-shadow: unset;
    }
}
</style>
